import { render, staticRenderFns } from "./addSku.vue?vue&type=template&id=092be86a"
import script from "./addSku.vue?vue&type=script&lang=js"
export * from "./addSku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports